/** Plain words for a failure the user can't act on beyond waiting: a proxy 502/503/504, or no response at all. */
export const SERVER_UNAVAILABLE_MESSAGE =
    'The server is not responding right now (it may be restarting). Please wait a minute and try again.';
export const NO_CONNECTION_MESSAGE =
    'Could not reach the server. Please check your internet connection and try again.';

/** True for an HTML error page (e.g. nginx "502 Bad Gateway"), which must never be shown as a message. */
export const looksLikeHtml = (text: string): boolean => /^\s*<(!doctype|html|head|body|center|h1)\b/i.test(text);

/** The message for an axios error the server never really answered, or undefined when the server did answer. */
export const unavailableMessage = (error: any): string | undefined => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    const ownMessage = data && typeof data === 'object' && typeof data.message === 'string' && data.message;
    if ((status === 502 || status === 503 || status === 504) && !ownMessage) return SERVER_UNAVAILABLE_MESSAGE;
    if (typeof data === 'string' && looksLikeHtml(data)) return SERVER_UNAVAILABLE_MESSAGE;
    if (!error?.response && error?.request) return NO_CONNECTION_MESSAGE;
    return undefined;
};
